import { InjectionToken } from '@angular/core';

export const VASS_CONFIG = new InjectionToken<any>('VASS_APP_CONFIG');
